export default "__VITE_ASSET__Byl$$Oft__"